var _style, _polygon, _path, _path2, _path3, _path4, _path5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path6, _path7, _polygon2, _circle, _polygon3, _path8, _line9, _line10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGurkha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st419{fill:#FFFFFF;}\n\t.st418{fill:#FFFFFF;stroke:#000000;stroke-width:3.43;stroke-miterlimit:10;}\n\t.st417{fill:#FFFFFF;stroke:#000000;stroke-width:1.14;stroke-miterlimit:10;}\n\t.st416{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:1.5;}\n\t.st415{fill:none;stroke:#000000;stroke-width:3.43;stroke-miterlimit:10;}\n\t.st414{fill:none;}\n\t.st413{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:1.54,1.54;}\n\t.st412{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st411{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:1.55,1.55;}\n\t.st410{fill:#FFFFFF;stroke:#010101;stroke-width:3.09;stroke-miterlimit:10;}\n\t.st409{fill:#FFFFFF;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st408{stroke:#000000;stroke-miterlimit:10;}\n\t.st407{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st419",
    points: "359.5,357.6 205.1,357.6 204.2,337.2 358.6,337.2 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st418",
    d: "M62.4,357.2c0.7-9.5,0.6-30.2,1.6-40.1c2.3-23.8,5.3-45.5,8.3-64.5c0.2-1.5,0.5-3,0.7-4.5 c2.5-15.7,5.1-29.5,7.4-41V207c8,2.1,18.7,4.6,31.5,6.7c2.9,0.5,10.2,1.7,20.6,2.9l-0.2,9.2L143,226l0.2-8.4c4.2,0.4,8.8,0.7,13.7,1 c1.5,0.1,3,0.2,4.6,0.2l4,0.2c14.4,0.6,27.5,0.3,38.5,0.1c2-0.1,4-0.1,6.1-0.2v26.8c-0.1,39.7,0.6,72.2,0.4,111.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st418",
    d: "M210.5,344.5L210.5,344.5c0.9,0,1.8,0.1,2.7,0.1c14,0.1,25.8-10.6,27.1-24.5V219.2c5.6,0,11.4-0.1,17.4-0.3 l4.5-0.2c5.5-0.2,11.1-0.6,17-1.1l2.3,1.3l3-0.3l5.4-2.1c6.6-0.8,13.5-1.7,20.7-2.9c11.7-2,21.7-4.2,29.2-6.1 c2.5,12.4,5.2,27.4,7.9,44.6c0.2,1.5,0.5,3,0.7,4.5c2.8,18,5.4,38.1,7.6,60.1c1.6,16.5,3.8,25.2,4.6,40.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st418",
    d: "M240.3,219.2v100.9c-1.3,14-13.1,24.6-27.1,24.5c-0.9,0-1.8-0.1-2.7-0.2c-0.1-36.8-0.2-73.6-0.4-110.5v-0.4 c0-4.9,0-9.8,0-14.8v-0.1h1.2c2.6,0.1,5,0.1,7.2,0.1C225.3,219.1,232.6,219.2,240.3,219.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st417",
    d: "M240.3,219.2v100.9c-1.3,14-13.1,24.6-27.1,24.5c-0.9,0-1.8-0.1-2.7-0.2H210V218.8h1.2c2.6,0.1,5,0.1,7.2,0.1 C225.3,219.1,232.6,219.2,240.3,219.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st416",
    d: "M213.1,343.1c-0.5,0-1.1,0-1.6-0.1V220.4c2.5,0.1,4.8,0.1,7,0.1c6.2,0.1,12.4,0.2,18.8,0.2h1.6V320 C237.6,333.2,226.4,343.3,213.1,343.1z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st415",
    x1: 291.5,
    y1: 216.5,
    x2: 356.4,
    y2: 321.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st414",
    x1: 287.5,
    y1: 215.6,
    x2: 358.6,
    y2: 331.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st413",
    x1: 288.7,
    y1: 217.5,
    x2: 357.8,
    y2: 329.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st412",
    x1: 358.2,
    y1: 330.4,
    x2: 358.6,
    y2: 331.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st414",
    x1: 136.9,
    y1: 214,
    x2: 62.8,
    y2: 328.3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st411",
    x1: 135.7,
    y1: 216,
    x2: 63.7,
    y2: 327
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st412",
    x1: 63.2,
    y1: 327.6,
    x2: 62.8,
    y2: 328.3
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st415",
    x1: 131.2,
    y1: 216.3,
    x2: 63.6,
    y2: 321.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st410",
    d: "M145.6,173.4c32.6,3.9,63.7,0.1,92.9-1c0.2,10.1,1.2,34.7,1.4,44.8c-15,1.1-27.5,1.5-36.8,1.7 c-24.5,0.4-54.3,0.8-90.8-5.5c-13.8-2.4-25-5.1-32.8-7.2c2.5-9.2,4.2-32.9,6.7-42.1L145.6,173.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st410",
    d: "M280.1,172.4c-12.9,1.5-41.5,1.3-66.1,3.5c-60.7,5.5-90.8,6.8-107.1,4.2c-2.6,4.4-11.2,12.1-11.2,12.1 c-0.2,0.4,5.7,7.8,10.2,12.1c27.4-2.1,71,9.7,111.5,14.6c24.3,3,54.3,0.8,90.8-5.5c13.8-2.4,25-5.1,32.8-7.2 c-2.5-9.2-5.8-32.9-8.3-42.1L280.1,172.4z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st409",
    points: "276.9,223 287.4,222.8 286.1,168.3 275.6,168.5 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st408",
    cx: 109.9,
    cy: 193.3,
    r: 6
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st409",
    points: "142.9,225.9 132.4,225.7 132.5,168.3 143,168.5 "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st407",
    d: "M167.5,218.5h-8.6c-3.9,0-7.1-3.5-7.1-7.7v-30.2c0-4.2,3.2-7.7,7.1-7.7h8.6c3.9,0,7.1,3.5,7.1,7.7v30.2 C174.6,215.1,171.4,218.5,167.5,218.5z"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st407",
    x1: 163.5,
    y1: 175.8,
    x2: 163.5,
    y2: 179.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st407",
    x1: 164,
    y1: 210.2,
    x2: 164,
    y2: 217.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGurkha);
export default __webpack_public_path__ + "static/media/GURKHA.96967b22ff059b07edb0e61ab41fdba2.svg";
export { ForwardRef as ReactComponent };